"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
exports.__esModule = true;
exports.InvoiceSources = exports.buildCodeSourceHeader = exports.buildInvoiceSourceHeader = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var artifact_types_lang_1 = require("../../artifacts/artifact-types.lang");
var code_sources_1 = require("./code-sources.tsx/code-sources");
var CLINICAL = 'CLINICAL';
var ASSEMBLED = 'ASSEMBLED';
var INVOICES_SORT_ORDER = {
    CLINICAL: 1,
    MAPPED: 2,
    PREDICTION: 3,
    PREDICTION_COMPONENT: 4,
    ASSEMBLED: 5,
    CODED: 6,
    PROCESSED: 7,
    SUBMITTED: 8
};
function buildInvoiceSourceHeader(invoiceType) {
    if (!invoiceType) {
        return '';
    }
    if (invoiceType in artifact_types_lang_1.AmplifyInvoiceSourceHeader) {
        return artifact_types_lang_1.AmplifyInvoiceSourceHeader[invoiceType];
    }
    else if (invoiceType in artifact_types_lang_1.ArtifactTypes) {
        return artifact_types_lang_1.ArtifactTypes[invoiceType];
    }
    return "From ".concat(invoiceType[0].toUpperCase() +
        invoiceType.slice(1).toLowerCase());
}
exports.buildInvoiceSourceHeader = buildInvoiceSourceHeader;
function buildCodeSourceHeader(invoiceType, sequenceNumber) {
    if (!invoiceType) {
        return '';
    }
    if (invoiceType === ASSEMBLED) {
        return "Transaction ".concat(sequenceNumber);
    }
    else if (invoiceType in artifact_types_lang_1.AmplifyCodeSourceHeader) {
        return artifact_types_lang_1.AmplifyCodeSourceHeader[invoiceType];
    }
    return '';
}
exports.buildCodeSourceHeader = buildCodeSourceHeader;
function InvoiceSources(_a) {
    var invoices = _a.invoices;
    if (!invoices || invoices.length === 0) {
        return (0, jsx_runtime_1.jsx)("span", { children: "No code sources available." });
    }
    var invoicesSorted = __spreadArray([], __read(invoices), false).sort(function (inv1, inv2) {
        return INVOICES_SORT_ORDER[inv1.type] - INVOICES_SORT_ORDER[inv2.type];
    });
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: "invoice-sources-tab" }, { children: invoicesSorted.map(function (invoice) {
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-source" }, { children: [(0, jsx_runtime_1.jsxs)("div", __assign({ className: "invoice-type-container" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "invoice-type" }, { children: buildInvoiceSourceHeader(invoice.type) })), invoice.type === CLINICAL && ((0, jsx_runtime_1.jsx)("div", __assign({ className: "clinical-source-provider" }, { children: invoice.performingProviderName })))] })), invoice.transactions.map(function (transaction, index) {
                        return ((0, jsx_runtime_1.jsx)(code_sources_1.CodeSources, { title: buildCodeSourceHeader(invoice.type, index + 1), diagnoses: transaction.diagnoses, modifiers: transaction.modifiers, procedures: transaction.procedures }, transaction.id));
                    })] }), invoice.id));
        }) })));
}
exports.InvoiceSources = InvoiceSources;
//# sourceMappingURL=invoice-sources.js.map